import React, { useEffect, useMemo, useRef, useState } from "react";

import { useTranslation } from "react-i18next";
import BGMode from "./bg-mode.webp";
import BGModeActive from "./bg-mode-active.webp";
import BGInput12 from "./bg-input-12.webp";
import BGInput8 from "./bg-input-8-rounded.webp";
import InfinityIcon from "./∞.webp";
import Up from "./up.webp";
import Submit from "./btn_cashout.png";
import Stop from "./btn-stop-bet.webp";
import BTNRandom from "./btn_PickRandomTitle.webp";
import AvatarIcon from "./avatar.webp";

import BGBarLandscape from "./bar-form-landscape.webp";
import BGRect from "./rect.png";
import "./index.scss";
import DropDown from "./dropdown";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import { getPlayer } from "../user/auth/reducer";
import { LimitBetKeys, Player } from "../user/auth/type";
import { formatCurrency } from "../../tool/money";
import useOrientation from "../hook/Orientation";
import {
  changeAmount,
  changeDifficulty,
  changeMode,
  changeNumOfBet,
  startBet,
  stopBet,
  updateTotalProfit,
} from "./reducer";
import {
  endAuto,
  resetResult,
  resultFinished,
  // sendAutoBetAction,
  sendBetAction,
  showError,
  startAuto,
} from "../result/reducer";
import { clearLastHistory, newRound } from "../history/reducer";
import { restart, restartAuto, selectToOpen } from "../game/reducer";
import { SendBet } from "../result/type";

import IconUser from "./../setting/ic-user.webp";
import IconWallet from "./../setting/ic-wallet.png";
import History from "../history";
import { chunkArray } from "../game";
import { debounce } from "../../tool/debounce";

let autotimeout: any;

/**
 * 
 * 
 *
 * 
 * 
{
    "mines": 8,
    "path": null | last position | all wanna open position | all open possition, 
    "round_id": 5,
    "state": initial | sweep | auto | cashout
  }
  
  
  */

// Todo ; remove potrait bottom empty space
// Todo ; ajust and clean manual bet component style

const BetBar = () => {
  const orientation = useOrientation();
  const dispatch = useAppDispatch();
  const playerbet = useAppSelector((state) => state.playerbet);
  const result = useAppSelector((state) => state.result);
  const history = useAppSelector((state) => state.history);
  const game = useAppSelector((state) => state.game);
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  // console.log(game.sele);
  const limit_bet = useAppSelector(
    (state) => state.auth.game?.limit_bet
  ) as Record<LimitBetKeys, number>;

  const ballList = playerbet.auto.difficulty_list;

  const player = useAppSelector(getPlayer) as Player;

  const status = useAppSelector((state) => state.result!.status);
  const [insuficient, setInsuficient] = useState(false);
  const [delayOnBet, setDelayOnBet] = useState(false);

  // useEffect(()=>{
  //   if(playerbet.manual.start || playerbet.auto.start) setDisable(true);
  // }, [playerbet.manual.start, playerbet.auto.start])

  useEffect(() => {
    if (status === "force-end-spin") {
      // handleStopAutoBet()
      dispatch(stopBet());
    }
  }, [status]);

  const { player_balance, player_name, player_currency } = player;

  const handleFormatCurrency = (amount: number): string => {
    return formatCurrency(amount, player_currency, language);
  };

  const defaultAmount = Number(limit_bet.minimal);
  const handleFormatAmount = (value: string = "") => {
    const newAmount = Number(
      value.split(".").join("").split("Rp").join("").split(",").join(".")
    ).toString();

    return newAmount;
  };

  const amountRef = useRef();

  const handleDecAmount = () => {
    // @ts-ignore
    if (amountRef.current.disabled) return;

    const newAmount =
      // @ts-ignore
      Number(handleFormatAmount(amountRef.current!.value)) * 0.5 >=
      limit_bet.minimal
        ? // @ts-ignore
          Number(handleFormatAmount(amountRef.current!.value)) * 0.5
        : Number(handleFormatAmount(limit_bet.minimal.toString()));
    // @ts-ignore
    amountRef.current!.value = handleFormatCurrency(newAmount);

    dispatch(
      // @ts-ignore
      changeAmount(Number(handleFormatAmount(amountRef.current!.value)))
    );
  };

  const handleIncAmount = () => {
    // @ts-ignore
    if (amountRef.current.disabled) return;
    const newAmount =
      // @ts-ignore
      Number(handleFormatAmount(amountRef.current!.value)) * 2 <=
      limit_bet.maximal
        ? // @ts-ignore
          Number(handleFormatAmount(amountRef.current!.value)) * 2
        : Number(handleFormatAmount(limit_bet.maximal.toString()));

    // @ts-ignore
    amountRef.current!.value = handleFormatCurrency(newAmount);
    // @ts-ignore
    dispatch(
      // @ts-ignore
      changeAmount(Number(handleFormatAmount(amountRef.current!.value)))
    );
  };

  const [mode, setMode] = useState<keyof typeof modes>("manual");
  const [stoping, setStoping] = useState(false);

  const handleDifficultyChange = (difficulty: string) => {
    if (
      playerbet.manual.start ||
      playerbet.auto.start ||
      playerbet[mode].difficulty == difficulty
    )
      return;
    dispatch(changeDifficulty({ mode, value: difficulty }));
    window.currPortalLevel = 1;
    dispatch(selectToOpen([]));
    dispatch(resultFinished());
    setTimeout(() => {
      dispatch(resetResult());
    }, 100);

    console.log("difficulty change", mode, orientation);
  };

  const modes = {
    auto: "",
    manual: "",
  };

  useEffect(() => {
    if (game.isOpenBomb) {
      setDelayOnBet(true);
      setTimeout(() => {
        setDelayOnBet(false);
      }, 2500);
    }
  }, [game.isOpenBomb]);

  // const [on_win_mode, setOnWinMode] = useState<"reset" | "increase-by">("reset");
  // const [on_loss_mode, setOnLossMode] = useState<"reset" | "increase-by">("increase-by");

  useEffect(() => {
    dispatch(changeMode(mode));
    if (!result.loadLastBet) {
      dispatch(resultFinished());
      setTimeout(() => {
        dispatch(resetResult());
      }, 100);
      dispatch(restart());
    }
    // @ts-ignore
    // dispatch(changeAmount(Number(handleFormatAmount(amountRef.current!.value))));
    // dispatch(changeAmount(Number(handleFormatAmount(amountRef.current!.value))));
    if (amountRef.current && playerbet[mode].amount) {
      // @ts-ignore
      amountRef.current!.value = handleFormatCurrency(playerbet[mode].amount);
      const changeEvent = new Event("change");
      // @ts-ignore
      amountRef.current!.dispatchEvent(changeEvent);
    }
  }, [mode]);

  useEffect(() => {
    // @ts-ignore
    const val = amountRef.current?.value;
    // @ts-ignore
    if (!Number.isNaN(Number(handleFormatAmount(val)))) {
      dispatch(changeAmount(Number(handleFormatAmount(val))));
    } // @ts-ignore
  }, [amountRef, amountRef.current, amountRef.current?.value]);

  window.handleCashOut = () => {
    if (delayOnBet) return;

    const sendBet: SendBet = {
      game: "DP000001",
      total_amount: playerbet.manual.amount,
      button_bet: {
        amount: playerbet.manual.amount,
        difficulty: playerbet.manual.difficulty,
        path: result.payload.path,
        round_id: Number(history.current_round),
        state: "cashout",
      },
      round_id: Number(history.current_round),
    };
    dispatch(sendBetAction(sendBet));
    dispatch(stopBet());
    setTimeout(() => {
      setDelayOnBet(false);
    }, 2500);
    setDelayOnBet(true);
  };

  const handleBet = () => {
    if (player_balance < (playerbet.manual.amount || defaultAmount)) {
      return dispatch(showError("BALANCE NOT ENOUGH"));
    }
    if (delayOnBet) return;
    window.currPortalLevel = 1;

    const sendBet: SendBet = {
      game: "DP000001",
      total_amount: playerbet.manual.amount || defaultAmount,
      button_bet: {
        amount: playerbet.manual.amount || defaultAmount,
        difficulty: playerbet.manual.difficulty,
        path: null,
        round_id: Number(history.current_round),
        state: "initial",
      },
      round_id: Number(history.current_round),
    };

    dispatch(sendBetAction(sendBet));
    dispatch(restart());
    dispatch(resultFinished());
    dispatch(resetResult());
    dispatch(updateTotalProfit(0));
    // setDelayOnBet(true)
    dispatch(startBet());
    // dispatch(newRound())

    // setTimeout(() => {
    //   setDelayOnBet(false);
    // }, 500);
  };

  const handleAutoBet = () => {
    if (player_balance < (playerbet.auto.amount || defaultAmount)) {
      return dispatch(showError("BALANCE NOT ENOUGH"));
    }
    if (!game.selected.length) {
      dispatch(resetResult());
      dispatch(showError("Pilih box dahulu!"));
    }

    if (!game.selected.length || playerbet.auto.start) return;
    dispatch(resultFinished());

    dispatch(restartAuto());
    dispatch(resetResult());

    dispatch(startBet());

    const sendBet: SendBet = {
      game: "DP000001",
      total_amount: playerbet.auto.amount || defaultAmount,
      button_bet: {
        amount: playerbet.auto.amount || defaultAmount,
        difficulty: playerbet.auto.difficulty,
        path: game.selected.join(","),
        round_id: Number(history.current_round),
        state: "auto",
      },
      round_id: Number(history.current_round),
    };
    dispatch(sendBetAction(sendBet));
  };

  const handleStopAutoBet = () => {
    if (stoping) return;
    // dispatch(resetResult());

    dispatch(stopBet());
    setStoping(true);
  };

  const user = useAppSelector(getPlayer) as Player;

  useEffect(() => {
    if (
      playerbet.currMode == "auto" &&
      !playerbet.auto.numberOfBet &&
      playerbet.auto.start
    ) {
      handleStopAutoBet();
    }
  }, [playerbet.auto.numberOfBet, playerbet.currMode]);

  useEffect(() => {
    if (
      !playerbet.auto.start &&
      stoping &&
      (result.status == "idle" || result.status == "reset")
    ) {
      setTimeout(() => {
        setStoping(false);
      }, 2000);
    }
  }, [playerbet.auto.start, stoping, result.status]);

  useEffect(() => {
    if (playerbet[mode].amount > user.player_balance) {
      setInsuficient(true);
    } else {
      setInsuficient(false);
    }
  }, [playerbet[mode].amount, user.player_balance]);

  const displayPlayerBalance = useMemo(
    () => formatCurrency(player_balance, player_currency, language),
    [player_balance, player_currency, language]
  );

  const lengthInfo = player_name.length + displayPlayerBalance.length;
  const current_round = useAppSelector(
    (state) => state.history.current_round
  ) as number;

  const modesComponent: any = {
    Auto: () => {
      return (
        <>
          <DropDown
            key={"bet-form-mines-auto"}
            className={"bet-form-mines"}
            label={t("betbar.difficulty")}
            options={ballList}
            setSelected={handleDifficultyChange}
            defaultValue={playerbet.auto.difficulty}
            disabled={playerbet.auto.start}
            bg={BGInput12}
          />
          <div className="form-group number_of_bets">
            <img className="bet-bg-input" alt="" src={BGInput12} />
            <label htmlFor="numberOfBet">{t("betbar.number_of_bets")}</label>
            <input
              //@ts-ignore
              // type="number"
              // id="amount"
              // name="amount"
              // value={playerbet.auto.numberOfBet}
              // onChange={(e)=>{
              //   if(!Number.isNaN(e.target.value))
              //   dispatch(changeNumOfBet(Number(e.target.value)));
              //   else e.target.value = "0";
              // }}

              //@ts-ignore
              // ref={amountRef}
              type="text"
              id="numberOfBet"
              name="numberOfBet"
              maxLength={7}
              disabled={playerbet[mode].start}
              value={playerbet.auto.numberOfBet}
              // value={(()=>{
              //   const newVal = playerbet[mode].amount < defaultAmount?defaultAmount:playerbet[mode].amount;
              //   dispatch(
              //     // @ts-ignore
              //     changeNumOfBet(newVal)
              //   );
              //                   return handleFormatCurrency(newVal);
              // })()}
              onKeyDownCapture={(e) => {
                var charTyped = e.key;
                var letterRegex = /[^0-9]/;
                if (!charTyped.match(letterRegex)) {
                  // return e.preventDefault();
                } else if (e.key == "Backspace") {
                } else if (e.key.indexOf("Arrow") > -1) {
                } else {
                  return e.preventDefault();
                }
              }}
              onChange={(e) => {
                if (
                  e.target.value !== "Infinity" &&
                  Number.isNaN(Number(e.target.value))
                )
                  return;
                dispatch(
                  // @ts-ignore
                  changeNumOfBet(Number(e.target.value))
                );

                if (Number(e.target.value) < 0) {
                  // e.target.value= "0"
                  changeNumOfBet(Number(0));
                }
              }}
              onFocus={({ target }) => {
                if (target.value === "Infinity" || target.value === "NaN") {
                  target.value = "0";
                }
              }}
              onBlur={({ target }) => {
                dispatch(changeNumOfBet(Number(target.value)));
              }}
            />
            <div className="bet-form-tool-list number-of-bets">
              <div
                className="tool-item"
                onClick={() => {
                  // handleDecAmount();
                }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {/* <img onContextMenu={(e)=>e.preventDefault()} draggable="false" className="bet-form-rect" alt="" src={Up} onClick={() => {
                if (!playerbet[mode].start)
                  dispatch(
                    changeNumOfBet(Number(playerbet.auto.numberOfBet) + 1)
                  );
              }} />
              <img onContextMenu={(e)=>e.preventDefault()} draggable="false" className="bet-form-rect" alt="" src={Up} style={{ transform: "rotate(180deg)" }} onClick={() => {
                if (Number(playerbet.auto.numberOfBet) - 1 >= 0)
                  if (!playerbet[mode].start)
                    dispatch(
                      changeNumOfBet(Number(playerbet.auto.numberOfBet) - 1)
                    );
              }} /> */}
                </div>
              </div>
              <div className="tool-item">
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <img
                    onContextMenu={(e) => e.preventDefault()}
                    draggable="false"
                    className="bet-form-rect"
                    alt=""
                    src={InfinityIcon}
                    onClick={() => {
                      if (!playerbet[mode].start)
                        dispatch(changeNumOfBet(Infinity));
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {true ? (
            playerbet.auto.start || stoping ? (
              <div
                style={{ filter: "invert(1)" }}
                className="form-group start-auto"
                onClick={handleStopAutoBet}
              >
                <img className="bet-button-bg" alt="" src={Submit} />
                <span className="button-text">
                  {stoping ? t(`betbar.stoping_auto`) : t(`betbar.stop_auto`)}
                </span>
              </div>
            ) : (
              <div className="form-group start-auto" onClick={handleAutoBet}>
                <img className="bet-button-bg" alt="" src={Submit} />
                <span className="button-text">{t(`betbar.start_auto`)}</span>
              </div>
            )
          ) : (
            <></>
          )}
        </>
      );
    },
    Manual: () => {
      return (
        <>
          {!playerbet.manual.start ? (
            <div className="form-group bet-form-on-win mines-gems">
              <div className="input">
                <div>
                  <DropDown
                    bg={BGInput12}
                    // toolicon={Bomb}
                    key={"bet-form-mines-manual"}
                    className={"bet-form-mines-manual"}
                    label={t("betbar.difficulty")}
                    options={ballList}
                    setSelected={handleDifficultyChange}
                    defaultValue={playerbet.manual.difficulty}
                    disabled={playerbet.manual.start}
                  />
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
          {
            // : <DropDown
            //   key={"bet-form-mines-manual-small"}
            //   className={"bet-form-mines"}
            //   label={t("betbar.mines")}
            //   options={ballList}
            //   setSelected={handleMinesChange}
            //   defaultValue={playerbet.manual.mines}
            //   disabled={playerbet.manual.start}
            // />
          }

          {playerbet.manual.start && !game.isOpenBomb && !delayOnBet ? (
            <div
              className="form-group bet-form-bet total-profit"
              style={{ marginTop: "-4.5rem !important" }}
            >
              <img className="bet-bg-input" alt="" src={BGInput12} />
              <label htmlFor="total_profit prevent-select">
                {t("betbar.total_profit")}{" "}
                {result.payload && result.payload.prize
                  ? result.payload.prize.toFixed(5)
                  : ""}
              </label>
              <input
                //@ts-ignore
                // ref={amountRef}
                type="text"
                id="total_profit"
                name="total_profit"
                // maxLength={7}
                value={handleFormatCurrency(playerbet.manual.total_profit || (result.payload && result.payload.prize ? result.payload.prize.toFixed(5)*result.payload.amount : 0))}

                disabled
              />
              <div className="bet-form-tool-list prevent-select"></div>
            </div>
          ) : (
            <></>
          )}

          {true ? (
            <>
              {playerbet.manual.start && !game.isOpenBomb && !delayOnBet ? (
                <div className="form-group start-auto random">
                  <img
                    className="bet-button-bg"
                    alt=""
                    src={BTNRandom}
                    onClick={() => {
                      console.log(window.currPortalLevel);
                      const currPortal = [
                        ...window.portals[orientation][
                          playerbet[playerbet.currMode].difficulty
                        ],
                      ].reverse();
                      chunkArray(
                        currPortal,
                        window.dataPos[orientation][
                          playerbet[playerbet.currMode].difficulty
                        ].col
                      ).map((chunk, idx) => {
                        if (idx + 1 == window.currPortalLevel) {
                          chunk[
                            Math.floor(Math.random() * chunk.length)
                          ].handleClick();
                        }
                      });
                    }}
                  />
                  <span
                    className="button-text prevent-select"
                    onClick={() => {
                      const currPortal = [
                        ...window.portals[orientation][
                          playerbet[playerbet.currMode].difficulty
                        ],
                      ].reverse();
                      chunkArray(
                        currPortal,
                        window.dataPos[orientation][
                          playerbet[playerbet.currMode].difficulty
                        ].col
                      ).map((chunk, idx) => {
                        if (idx + 1 == window.currPortalLevel) {
                          chunk[
                            Math.floor(Math.random() * chunk.length)
                          ].handleClick();
                        }
                      });
                    }}
                  >
                    {t(`betbar.pick_random`)}
                  </span>
                </div>
              ) : (
                <></>
              )}
              {playerbet.manual.start &&
              game.openCount > 0 &&
              !game.isOpenBomb ? (
                <div
                  className="form-group start-auto cash_out"
                  style={{ marginTop: "-1.5rem !important" }}
                >
                  <img
                    className="bet-button-bg"
                    alt=""
                    src={Submit}
                    onClick={() => window.handleCashOut()}
                  />
                  <span
                    className="button-text prevent-select"
                    onClick={() => window.handleCashOut()}
                  >
                    {t(`betbar.cash_out`)}
                  </span>
                </div>
              ) : (
                <></>
              )}

              {!playerbet.manual.start ? (
                <div
                  style={{ filter: delayOnBet ? "grayscale(1)" : "none" }}
                  className="form-group start-auto"
                  onClick={debounce(() => handleBet(), 1000)}
                >
                  <img className="bet-button-bg" alt="" src={Submit} />
                  <span className="button-text prevent-select">
                    {t(`betbar.start`)}
                  </span>
                </div>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}
        </>
      );
    },
  };

  return (
    <div className="bet-wrapper">
      <div className="bet">
        <div
          className="bet-bg"
          // alt=""
          // src={orientation == "landscape" ? BGBarLandscape : BGBarPortrait}
        />

        <div
          className={`header-info${lengthInfo > 30 ? " header-info-sm" : ""}`}
        >
          {/* <img onContextMenu={(e) => e.preventDefault()} draggable="false" className="header-avatar-icon" alt="" src={AvatarIcon} /> */}
          <div className="right">
            <div className="header-info-content">
              {/* <img onContextMenu={(e) => e.preventDefault()} draggable="false" className="header-info-icon" alt="" src={IconUser} /> */}

              <span className="header-info-user-value">{player_name}</span>
            </div>

            <div className="header-info-content">
              <img
                onContextMenu={(e) => e.preventDefault()}
                draggable="false"
                className="header-info-icon"
                alt=""
                src={IconWallet}
              />

              <span className="header-info-balance-value">
                {displayPlayerBalance}
              </span>
            </div>
          </div>
        </div>

        <div className={"bet-form ".concat(mode)}>
          <div className="form-group mode">
            <img className="bet-bg-mode" alt="" src={BGMode} />

            <div className="mode-container">
              <div
                className="mode-overlay"
                onClick={() => {
                  if (mode == "manual" && playerbet[mode].start) return;
                  if (mode == "auto" && playerbet[mode].start) return;
                  setMode((old) => (old === "manual" ? "auto" : "manual"));
                }}
              ></div>

              <img
                className={"bet-bg-mode-active ".concat(
                  mode === "auto" ? "auto" : ""
                )}
                alt=""
                src={BGModeActive}
              />
              <span>Manual</span>
              <span>Auto</span>
            </div>
          </div>
          <div
            className="form-group bet-form-bet"
            style={{ marginTop: "-6rem" }}
          >
            <img className="bet-bg-input" alt="" src={BGInput8} />
            <label htmlFor="amount">{t("betbar.bet_amount")}</label>
            <input
              //@ts-ignore
              ref={amountRef}
              type="text"
              id="amount"
              name="amount"
              maxLength={7}
              disabled={playerbet[playerbet.currMode].start}
              defaultValue={handleFormatCurrency(defaultAmount)}
              onKeyDownCapture={(e) => {
                const charTyped = e.key;
                const letterRegex = /[^0-9]/;
                if (!charTyped.match(letterRegex)) {
                  try {
                    if (
                      // @ts-ignore
                      e.target.value.split(".")[1].length >= 2 &&
                      // @ts-ignore
                      window.getSelection().getRangeAt(0).startOffset ==
                      // @ts-ignore
                        e.target.value.length
                    ) {
                      return e.preventDefault();
                    }
                  } catch (error) {}
                } else if (e.key == "Backspace") {
                } else if (e.key.indexOf("Arrow") > -1) {
                } else if (e.key == ".") {
                  // @ts-ignore
                  if (e.target.value.indexOf(".") > 0) {
                    return e.preventDefault();
                  }
                } else {
                  return e.preventDefault();
                }
              }}
              onChange={(e) => {
                if (Number.isNaN(Number(e.target.value))) return;
                dispatch(
                  // @ts-ignore
                  changeAmount(Number(handleFormatAmount(e.target.value)))
                );
              }}
              onFocus={({ target }) => {
                target.value = playerbet[playerbet.currMode].amount.toString();
              }}
              onBlur={({ target }) => {
                if (limit_bet.minimal >= Number(target.value)) {
                  target.value = handleFormatCurrency(
                    Number(limit_bet.minimal)
                  );
                } else if (limit_bet.maximal <= Number(target.value)) {
                  target.value = handleFormatCurrency(
                    Number(limit_bet.maximal)
                  );
                } else {
                  target.value = handleFormatCurrency(Number(target.value));
                }

                dispatch(
                  changeAmount(Number(handleFormatAmount(target.value)))
                );
              }}
            />
            <div className="bet-form-tool-list">
              <div
                className="tool-item"
                onClick={() => {
                  handleDecAmount();
                }}
              >
                <span>1/2</span>
                <img
                  onContextMenu={(e) => e.preventDefault()}
                  draggable="false"
                  className="bet-form-rect"
                  alt=""
                  src={BGRect}
                />
              </div>
              <div className="tool-item" onClick={() => handleIncAmount()}>
                <span className="x2">2x</span>
                <img
                  onContextMenu={(e) => e.preventDefault()}
                  draggable="false"
                  className="bet-form-rect"
                  alt=""
                  src={BGRect}
                />
              </div>
            </div>
          </div>
          {modesComponent[mode.charAt(0).toUpperCase() + mode.slice(1)]()}
        </div>
      </div>
    </div>
  );
};

export default BetBar;
